import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '';

function buildUrl(path) {
  return `${API_BASE.replace(/\/$/, '')}${path}`;
}

function imageSrc(path) {
  if (!path) return '';
  const p = String(path).trim();
  if (typeof window !== 'undefined' && p.startsWith('/uploads/')) {
    return window.location.origin + (p.startsWith('/') ? p : '/' + p);
  }
  if (p.startsWith('http://') || p.startsWith('https://')) return p;
  if (typeof window !== 'undefined') return window.location.origin + (p.startsWith('/') ? p : '/' + p);
  return p;
}

function AdminDashboard() {
  const [stats, setStats] = useState({ gallery: 0, videos: 0, reviews: 0 });
  const [recentGallery, setRecentGallery] = useState([]);
  const [recentVideos, setRecentVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const fetchStats = async () => {
      try {
        const res = await fetch(buildUrl('/api/dashboard/stats'));
        const data = await res.json();
        if (cancelled) return;
        if (res.ok && data.success) {
          setStats({
            gallery: data.gallery ?? 0,
            videos: data.videos ?? 0,
            reviews: data.reviews ?? 0,
          });
          setRecentGallery(Array.isArray(data.recentGallery) ? data.recentGallery : []);
          setRecentVideos(Array.isArray(data.recentVideos) ? data.recentVideos : []);
        }
      } catch (_e) {
        // ignore
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    fetchStats();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="admin-dashboard">
      <h1 className="admin-dashboard-title">Dashboard</h1>
      <div className="admin-dashboard-section">
        <h2 className="admin-section-title">Content summary</h2>
        <p className="admin-section-description">
          Quick overview of your site. Use the menu on the left to manage the gallery, videos, and reviews.
        </p>
        <div className="admin-dashboard-cards">
          <div className="admin-card">
            <div className="admin-card-body">
              <span className="admin-card-label">Gallery items</span>
              <span className="admin-card-value">{loading ? '…' : stats.gallery}</span>
            </div>
          </div>
          <div className="admin-card">
            <div className="admin-card-body">
              <span className="admin-card-label">Videos</span>
              <span className="admin-card-value">{loading ? '…' : stats.videos}</span>
            </div>
          </div>
          <div className="admin-card">
            <div className="admin-card-body">
              <span className="admin-card-label">Reviews</span>
              <span className="admin-card-value">{loading ? '…' : stats.reviews}</span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: '1.25rem' }}>
          <h2 className="admin-section-title admin-section-title--small">Add video</h2>
          <Link to="/admin/videos" className="admin-video-add-toggle-btn">
            <i className="far fa-plus" /> Add video
          </Link>
        </div>

        {!loading && (recentGallery.length > 0 || recentVideos.length > 0) && (
          <div className="admin-dashboard-details">
            {recentGallery.length > 0 && (
              <div className="admin-dashboard-detail-block">
                <h3 className="admin-section-title admin-section-title--small">Recent gallery</h3>
                <ul className="admin-detail-list">
                  {recentGallery.map((item) => (
                    <li key={item._id} className="admin-detail-item">
                      <img src={imageSrc(item.image)} alt="" className="admin-detail-thumb" />
                      <span className="admin-detail-title">{item.title || 'Untitled'}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/admin/gallery" className="admin-detail-link">View all gallery</Link>
              </div>
            )}
            {recentVideos.length > 0 && (
              <div className="admin-dashboard-detail-block">
                <h3 className="admin-section-title admin-section-title--small">Recent videos</h3>
                <ul className="admin-detail-list">
                  {recentVideos.map((v) => (
                    <li key={v._id} className="admin-detail-item admin-detail-item--video">
                      <span className="admin-detail-title">{v.title}</span>
                      <span className="admin-detail-meta">{v.category}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/admin/videos" className="admin-detail-link">View all videos</Link>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
